<template>
  <div class="row category-wrapper electronics-cosmetics mb-7">
    <div
      class="col-md-6 mb-4"
      v-for="(item, index) in [gongsi1, gongsi2]"
      :key="index"
    >
      <div class="banner banner-fixed br-sm">
        <figure>
          <img
            :src="item.banner ? item.banner : $tupianmoren"
            style="background-color: #25282d; width: 640px; height: 200px"
          />
        </figure>
        <div class="banner-content y-50">
          <h3 class="banner-title text-white ls-25 mb-0 hang-2">
            {{ duoyuyan(item) }}
          </h3>
          <div
            class="banner-price-info text-white font-weight-bold text-uppercase mb-1"
          >
            <strong
              class="text-secondary hang-2"
              v-html="duoyuyan(item, 'miaoshu')"
            >
            </strong>
          </div>
          <router-link
            :to="{ path: '/boutique', query: { ukey: item.ukey } }"
            class="btn btn-white btn-link btn-underline btn-icon-right"
          >
            {{ $yuyanbao.miaofeibaojia }}
            <i class="w-icon-long-arrow-right"></i>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGongSi } from "@/api/gongsi";

export default {
  name: "IndexProduct",
  props: {},
  data() {
    return {
      gongsi1: {},
      gongsi2: {},
    };
  },
  mounted() {
    this.get_gongsi_http();
  },
  methods: {
    get_gongsi_http() {
      getGongSi({ ukey: this.$shezhi.indexgongsi1ukey }).then((data) => {
        if (data.status === "SUCCESSED") this.gongsi1 = data.data;
      });
      getGongSi({ ukey: this.$shezhi.indexgongsi2ukey }).then((data) => {
        if (data.status === "SUCCESSED") this.gongsi2 = data.data;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
